import router from "@/router";
import moment from "moment";

const getOrCreateTooltip = (chart) => {
    let tooltipEl = chart.canvas.parentNode.querySelector('div');

    if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.style.background = 'rgba(255, 255, 255, 1)';
        tooltipEl.style.boxShadow = '0 1px 2px 0 rgba(25, 27, 35, 0.12)';
        tooltipEl.style.borderRadius = '3px';
        tooltipEl.style.color = 'black';
        tooltipEl.style.opacity = 1;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.transform = 'translate(-50%, 0)';
        tooltipEl.style.transition = 'all .1s ease';

        const table = document.createElement('table');
        table.style.margin = '0px';

        tooltipEl.appendChild(table);
        chart.canvas.parentNode.appendChild(tooltipEl);
    }

    return tooltipEl;
};
export const externalTooltipHandler = (context) => {
    const {chart, tooltip} = context;
    const tooltipEl = getOrCreateTooltip(chart);

    if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
    }

    if (tooltip.body) {
        const titleLines = tooltip.title || [];
        const bodyLines = tooltip.body.map(b => b.lines);

        const tableHead = document.createElement('thead');

        titleLines.forEach(title => {
            const tr = document.createElement('tr');
            tr.style.borderWidth = 0;

            const th = document.createElement('th');
            th.style.borderWidth = 0;
            const text = document.createTextNode(title);
            th.style.color = '#6C6E79';
            th.style.fontSize = '16px';

            th.appendChild(text);
            tr.appendChild(th);
            tableHead.appendChild(tr);
        });

        const tableBody = document.createElement('tbody');
        bodyLines.forEach((body, i) => {
            const colors = tooltip.labelColors[i];

            const span = document.createElement('span');
            span.style.background = colors.backgroundColor;
            span.style.borderColor = colors.borderColor;
            span.style.borderWidth = '2px';
            span.style.marginRight = '10px';
            span.style.borderRadius = '10px';
            span.style.height = '10px';
            span.style.width = '10px';
            span.style.display = 'inline-block';

            const tr = document.createElement('tr');
            tr.style.backgroundColor = 'inherit';
            tr.style.borderWidth = 0;

            const td = document.createElement('td');
            td.style.borderWidth = 0;

            const text = document.createTextNode(body);

            td.appendChild(span);
            td.appendChild(text);
            tr.appendChild(td);
            tableBody.appendChild(tr);
        });

        const tableRoot = tooltipEl.querySelector('table');

        while (tableRoot.firstChild) {
            tableRoot.firstChild.remove();
        }

        tableRoot.appendChild(tableHead);
        tableRoot.appendChild(tableBody);
    }

    const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas;

    tooltipEl.style.opacity = 1;
    tooltipEl.style.left = positionX + tooltip.caretX + 'px';
    tooltipEl.style.top = positionY + tooltip.caretY + 'px';
    tooltipEl.style.font = tooltip.options.bodyFont.string;
    tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
};

export function convertPeriodToDateRange(type, value, contextYear = null) {
    let start, end;
    let currentYear = contextYear || new Date().getFullYear();

    const parseRussianMonth = (monthName) => {
        const months = {
            'Январь': 0, 'Февраль': 1, 'Март': 2, 'Апрель': 3,
            'Май': 4, 'Июнь': 5, 'Июль': 6, 'Август': 7,
            'Сентябрь': 8, 'Октябрь': 9, 'Ноябрь': 10, 'Декабрь': 11
        };
        return months[monthName];
    };

    const toDateOnly = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

    switch (type) {
        case 'day': {
            const [day, month, year] = value.split('.');
            start = new Date(year, month - 1, day);
            end = new Date(year, month - 1, day, 23, 59, 59);
            break;
        }

        case 'week': {
            let date = new Date(value.split('.').reverse().join('-'));
            let dayOfWeek = date.getDay(); // 0 вс, 1 пн...
            let diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
            start = new Date(date);
            start.setDate(date.getDate() + diffToMonday);
            start = toDateOnly(start);
            end = new Date(start);
            end.setDate(start.getDate() + 6);
            end.setHours(23, 59, 59);
            break;
        }

        case 'month': {
            let monthIndex = parseRussianMonth(value);
            if (monthIndex === undefined) throw new Error(`Unknown month: ${value}`);
            start = new Date(currentYear, monthIndex, 1);
            end = new Date(currentYear, monthIndex + 1, 0);
            end.setHours(23, 59, 59);
            break;
        }

        case 'quarter': {
            const quarterMap = {
                'Янв-Мар': {startMonth: 0, endMonth: 2},
                'Апр-Июн': {startMonth: 3, endMonth: 5},
                'Июл-Сен': {startMonth: 6, endMonth: 8},
                'Окт-Дек': {startMonth: 9, endMonth: 11}
            };
            const q = quarterMap[value];
            if (!q) throw new Error(`Unknown quarter: ${value}`);
            start = new Date(currentYear, q.startMonth, 1);
            end = new Date(currentYear, q.endMonth + 1, 0);
            end.setHours(23, 59, 59);
            break;
        }

        case 'half_year': {
            const [hyear, hhalf] = value.split('-');
            const yearNum = parseInt(hyear, 10);
            if (hhalf === '1') {
                start = new Date(yearNum, 0, 1);
                end = new Date(yearNum, 5, 30);
            } else {
                start = new Date(yearNum, 6, 1);
                end = new Date(yearNum, 11, 31);
            }
            end.setHours(23, 59, 59);
            break;
        }

        case 'year': {
            const yearNum = parseInt(value, 10);
            start = new Date(yearNum, 0, 1);
            end = new Date(yearNum, 11, 31);
            end.setHours(23, 59, 59);
            break;
        }

        default:
            throw new Error(`Unknown period type: ${type}`);
    }
    start = moment(start).format("YYYY-MM-DD")
    end = moment(end).format("YYYY-MM-DD")
    return {start, end};
}

export const handleChartClick = (router, getQueryValue) => {
    return (event, activeElements, chart) => {
        if (activeElements.length === 0) return;
        let dataIndex = null;
        let clickedLabel = null;
        let labelId = null;
        if (activeElements.length > 1) {
            const points = chart.getElementsAtEventForMode(event, 'nearest', {intersect: true}, false);
            if (!points.length) return;
            const point = points[0]
            clickedLabel = chart.data.labels[point.index]

            dataIndex = chart.data.datasets[point.datasetIndex].label
            labelId = chart.data.datasets[point.datasetIndex].label_id
        } else {
            dataIndex = activeElements[0].index;
            clickedLabel = chart.data.labels[dataIndex];
        }
        const queryValue = getQueryValue(dataIndex, clickedLabel, labelId);
        if (!queryValue) return;

        const routeUrl = router.resolve({
            name: 'project_reviews',
            query: queryValue
        }).href;

        window.open(routeUrl, '_blank');
    };
};